import { render, staticRenderFns } from "./PbTerms.vue?vue&type=template&id=b27a5894"
import script from "./PbTerms.vue?vue&type=script&lang=js"
export * from "./PbTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports